const claimTypeAvailabilityLabelStrings = {
  noDateSelected: "Velg dato først for å vise tilgjengelige mottakere",
  noSalariesOnDate: "Honorar er ikke tilgjengelig på valgt dato"
};

export default claimTypeAvailabilityLabelStrings;